import { ThemeProvider } from '@mui/material/styles';

import { Box } from '@mui/material';

import theme from './theme';

import Header from './components/Header'
import Footer from './components/Footer'
import Firmware from './components/Firmware'
import Images from './components/Images'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ m: 10 }}>
        <Header />
        <Firmware />
        <Images />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
